import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import DisneyApp from './DisneyApp';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <DisneyApp />,
  document.getElementById('root')
);

// If you want to start measuring performance in your Disneyapp, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
